import { render } from "./GroupDetailVx.vue?vue&type=template&id=a9d8f200"
import script from "./GroupDetailVx.vue?vue&type=script&lang=js"
export * from "./GroupDetailVx.vue?vue&type=script&lang=js"

import "./GroupDetailVx.vue?vue&type=style&index=0&id=a9d8f200&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__